var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr-scanner",class:{'full-scanner': _vm.userInfo.scanMode == 'full'}},[_c('div',{},[_c('div',{staticClass:"close-web-camera",on:{"click":_vm.close}},[_c('i',{staticClass:"bx bx-x"})]),_c('div',{staticClass:"reader",attrs:{"id":"reader"}}),_c('div',{staticClass:"qr-box"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }